import React, { useEffect } from "react";
import { VerticalTimeline } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { useLanguage } from "../i18n/LanguageContext";
import { experiencesData, volunteerData } from "../data/experiencesData";
import ExperienceItem from "../components/ExperienceItem";
import "../components/css/experience.css";

export default function Experience() {
  const { t, localize, language } = useLanguage();
  const timelineLayout = language === "ar" ? "1-column-right" : "1-column-left";
  useEffect(() => {
    document
      .querySelector('meta[name="keywords"]')
      ?.setAttribute(
        "content",
        "software engineer, Kuwait, Phinests, Ruby on Rails, React, SOC Analyst, Kuwait Finance House, volunteering, KFAS, CODED",
      );
  }, []);

  return (
    <div id="experience" className="experience career-editorial">
      <header className="career-intro">
        <h1>
          {t("career.heading").split(/(&)/).map((part, index) =>
            part === "&" ? <span className="career-title-accent" key={index}>{part}</span> : part,
          )}<span className="career-title-accent" aria-hidden="true">.</span>
        </h1>
        <p className="career-tagline">{t("career.tagline")}</p>
      </header>

      {/* =================================== */}
      {/* =============== WORK ============== */}
      {/* =================================== */}
      <section
        aria-label={t("career.work")}
        className="timeline career-timeline"
      >
        <VerticalTimeline layout={timelineLayout} animate={true}>
          {localize(experiencesData).map((experience) => (
            <ExperienceItem
              key={experience.companyName}
              experience={experience}
            />
          ))}
        </VerticalTimeline>
      </section>

      {/* =================================== */}
      {/* =========== VOLUNTEER ============= */}
      {/* =================================== */}
      <section
        className="timeline career-timeline career-community"
        aria-labelledby="career-community-heading"
      >
        <h2 id="career-community-heading">{t("career.community")}</h2>
        <VerticalTimeline layout={timelineLayout} animate={true}>
          {localize(volunteerData).map((experience) => (
            <ExperienceItem
              key={experience.companyName}
              experience={experience}
              volunteer
            />
          ))}
        </VerticalTimeline>
      </section>
    </div>
  );
}
